"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANVA_TEMPLATE_OPTIONS = exports.CANVA_DEFAULT_TEMPLATE = exports.CANVA_API_KEY = void 0;
var CANVA_API_KEY = '4PDQqridTXh-uraMlWlSqCU4';
exports.CANVA_API_KEY = CANVA_API_KEY;
var CANVA_DEFAULT_TEMPLATE = 'SocialMedia';
exports.CANVA_DEFAULT_TEMPLATE = CANVA_DEFAULT_TEMPLATE;
var CANVA_TEMPLATE_OPTIONS = [{
  icon: 'socialBlockFacebook',
  languageKey: 'facebook',
  value: 'FacebookPost'
}, {
  icon: 'socialBlockInstagram',
  languageKey: 'instagramLandscape',
  value: 'custom:InstagramPost:1080x607'
}, {
  icon: 'socialBlockInstagram',
  languageKey: 'instagramPortrait',
  value: 'custom:InstagramPost:1080x1350'
}, {
  icon: 'socialBlockInstagram',
  languageKey: 'instagramPost',
  value: 'InstagramPost'
}, {
  icon: 'socialBlockLinkedin',
  languageKey: 'linkedIn',
  value: 'LinkedInBanner'
}, {
  icon: 'socialBlockTwitter',
  languageKey: 'twitter',
  value: 'TwitterPost'
}];
exports.CANVA_TEMPLATE_OPTIONS = CANVA_TEMPLATE_OPTIONS;